import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-32 bg-[#18181B] px-4 text-center relative overflow-hidden" data-id="element-69">
      {/* Radial gradient background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-zinc-800 via-zinc-900 to-black opacity-80 pointer-events-none" data-id="element-70"></div>

      {/* Floating decorative elements */}
      <div className="absolute top-20 left-20 w-64 h-64 bg-emerald-500 rounded-full blur-[100px] opacity-20 animate-pulse" data-id="element-71"></div>
      <div className="absolute bottom-20 right-20 w-80 h-80 bg-amber-500 rounded-full blur-[100px] opacity-20 animate-pulse delay-1000" data-id="element-72"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-73">
        <h2 className="text-4xl md:text-6xl font-black text-white mb-8 leading-tight tracking-tight drop-shadow-lg" data-id="element-74">
          Tu bienestar en la menopausia puede ser más simple
        </h2>

        <p className="text-xl md:text-2xl text-gray-400 mb-14 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-75">
          No necesitás más fuerza de voluntad. Necesitás un sistema diseñado
          específicamente para tu etapa.
        </p>

        <a href="#compra" className="inline-flex items-center gap-3 bg-emerald-600 hover:bg-emerald-700 text-white text-xl md:text-2xl font-bold py-5 px-10 rounded-full shadow-2xl hover:shadow-emerald-500/40 transition-all transform hover:-translate-y-1 group border border-emerald-500/50 relative overflow-hidden" data-id="element-76">
          <span className="relative z-10 flex items-center gap-2" data-id="element-77">
            Accedé ahora al Manual
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-78" />
          </span>
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1s_infinite]" data-id="element-79"></div>
        </a>
      </div>
    </section>;
}